// src/api/authApi.ts
const TOKEN_KEY = 'finz_token';
const USER_KEY = 'finz_user';

const authApi = {
  login: async (email: string, password: string) => {
    // For now: accept any credentials and store a demo token
    localStorage.setItem(TOKEN_KEY, 'demo-token');
    localStorage.setItem(USER_KEY, JSON.stringify({ email }));
    return { ok: true };
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  isAuthed: () => Boolean(localStorage.getItem(TOKEN_KEY)),
  getUser: () => {
    try { return JSON.parse(localStorage.getItem(USER_KEY) || '{}'); }
    catch { return {}; }
  },
  requestPasswordReset: async (email: string) => {
    // Mock API call
    console.log(`Password reset requested for: ${email}`);
    await new Promise(resolve => setTimeout(resolve, 1000));
    return { ok: true };
  }
};

export default authApi;

